import { resolveMessengerV2Manager } from './messengerV2MlsGateway.js';

const DEFAULT_MLS_CIPHERSUITE = 0x004d;

const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

export const ensureMessengerV2Bootstrap = async ({
  manager = null,
  currentUserId,
  currentUserName = null,
  preferredCiphersuite = DEFAULT_MLS_CIPHERSUITE,
  forcePublish = false,
} = {}) => {
  const normalizedCurrentUserId = toStringOrNull(currentUserId);
  if (!normalizedCurrentUserId) {
    throw new Error('currentUserId is required');
  }

  const identityName = currentUserName || `user-${normalizedCurrentUserId}`;
  const resolvedManager =
    manager ||
    resolveMessengerV2Manager({
      userId: normalizedCurrentUserId,
      identityName,
      preferredCiphersuite,
      wantPQ: true,
      serverManaged: true,
    });

  if (!resolvedManager) {
    throw new Error('MLS manager unavailable for bootstrap');
  }

  const result =
    (await resolvedManager.ensureBootstrapReady?.({
      name: identityName,
      ciphersuite: preferredCiphersuite,
      forcePublish,
    })) || null;

  if (result?.ready === true) {
    // Do not make login wait for every dormant conversation. Keep the
    // server-computed one-time package reserve warm in a device-scoped
    // background single-flight so all direct/group recoveries have supply.
    void Promise.resolve(
      resolvedManager.replenishKeyPackageInventory?.({ identity: result?.identity ?? null }),
    ).catch((error) => {
      if (typeof console?.warn === 'function') {
        console.warn('[MLS V2] background key-package inventory refill failed', error);
      }
    });
  }

  return {
    manager: resolvedManager,
    identity: result?.identity ?? null,
    identityId:
      toStringOrNull(result?.identityId ?? null) ||
      toStringOrNull(resolvedManager.identityClientId) ||
      toStringOrNull(resolvedManager.identityId) ||
      null,
    clientId:
      toStringOrNull(result?.clientId ?? null) ||
      toStringOrNull(resolvedManager.identityClientId) ||
      null,
    ciphersuite: result?.ciphersuite ?? preferredCiphersuite,
    keyPackageStatus: toStringOrNull(result?.keyPackageStatus ?? null) || 'unknown',
    keyPackageRef: toStringOrNull(result?.keyPackageRef ?? null),
    publishResult: result?.publishResult ?? null,
    welcomeRecovery: result?.welcomeRecovery ?? null,
    recoveryDegraded: result?.recoveryDegraded === true,
    ready: result?.ready === true,
  };
};

export default ensureMessengerV2Bootstrap;
